(function () {
    'use strict';
    a3_cabin_reports.factory('IndexedDBService', IndexedDBService);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name IndexedDBService
     * @description 
     *    Generic add, edit or remove for IndexedDB
     * @ngInject
     */
    function IndexedDBService($q, LogService) {
        var idbSupported = ("indexedDB" in window);
        if (!idbSupported) {
            LogService.debug("No IndexedDb is supported for this browser's version");
        }
        

        
        return {
            /**
             * initiate or update indexedDB storage
             * @memberof IndexedDBService
             * @returns {object} promise
             */
            init: function () {
                var deferred = $q.defer();
                var request = indexedDB.open("a3.cabin.reports", 11);

                request.onupgradeneeded = function (e) {
                    // The database did not previously exist, so create object stores and indexes.
                    var db = request.result;
                    if (e.oldVersion < 1) {
                        var gameStore = db.createObjectStore("Memos", {
                            keyPath: "Id"
                        });
                        gameStore.createIndex("id_idx", "Id", {
                            unique: true
                        });
                    }
                    if (e.oldVersion < 2) {
                        var gameStore1 = db.createObjectStore("MemoImages", {
                            keyPath: "imageId"
                        });
                        gameStore1.createIndex("id_idx", "imageId", {
                            unique: true
                        });
                        gameStore1.createIndex("memoId", "memoId", {
                            unique: false
                        });
                    }
                    if (e.oldVersion < 5 && !db.objectStoreNames.contains('PaxInfo')) {
            
                        var gameStore2 = db.createObjectStore("PaxInfo", {
                            keyPath: "FlightId"
                        });
                        gameStore2.createIndex("id_idx", "FlightId", {
                            unique: true
                        });
                    }
                    if (e.oldVersion <= 6 && !db.objectStoreNames.contains('Reports')) {
            
                        var gameStore3 = db.createObjectStore("Reports", {
                            keyPath: "FlightId"
                        });
                        gameStore3.createIndex("id_idx", "FlightId", {
                            unique: true
                        });
                    }
                    if (e.oldVersion <= 7 && !db.objectStoreNames.contains('Courses')) {
                        var gameStore3 = db.createObjectStore("Courses", {
                            keyPath: "Id"
                        });
                        gameStore3.createIndex("id_idx", "Id", {
                            unique: true
                        });
                        
                        var store4 = db.createObjectStore("TrainingSessions", {
                              keyPath: ['day', 'courseId','dutyId']
                        });
                        
                        store4.createIndex("id_idx", ['day', 'courseId','dutyId'], {
                            unique: true
                        });
                        
                        store4.createIndex("day_idx", "day", {
                            unique: false
                        });
                        
                        store4.createIndex("courseId_idx", "courseId", {
                            unique: false
                        });
                    }
                    if (e.oldVersion <= 8 && !db.objectStoreNames.contains('FlightSessions')) {
                        
                        var store = db.createObjectStore("FlightSessions", {
                              keyPath: ['day', 'courseId','dutyNo', 'dutyDay']
                        });
                        

                        store.createIndex("id_idx", ['day', 'courseId', 'dutyNo', 'dutyDay'], {
                            unique: true
                        });
                        
                        store.createIndex("day_idx", "day", {
                            unique: false
                        });
                        
                        store.createIndex("courseId_idx", "courseId", {
                            unique: false
                        });
                    }
                    if (e.oldVersion <= 9 && !db.objectStoreNames.contains('ToolkitItems')) {
            
                        var gameStore2 = db.createObjectStore("ToolkitItems", {
                            keyPath: "Id"
                        });
                        gameStore2.createIndex("id_idx", "Id", {
                            unique: true
                        });
                    }
                    if (e.oldVersion <= 10 && !db.objectStoreNames.contains('PassengerMealServices')) {
            
                        var gameStore = db.createObjectStore("PassengerMealServices", {
                            keyPath: "Id"
                        });
                        gameStore.createIndex("id_idx", "Id", {
                            unique: true
                        });
                    }
                    if (e.oldVersion <= 11 && !db.objectStoreNames.contains('AllExpiries')) {
            
                        var gameStore = db.createObjectStore("AllExpiries", {
                            keyPath: "ExpiryTypeId"
                      });
                      
                        gameStore.createIndex("id_idx", "ExpiryTypeId", {
                            unique: true
                        });
                    }
                };

                request.onsuccess = function () {
                    deferred.resolve(request.result);
                };

                request.onerror = function () {
                    LogService.error(request.error);
                    deferred.reject(request.error);
                };

                return deferred.promise;
            },

            deleteDatabase: function (callback) {
                var deferred = $q.defer();
                var request = indexedDB.deleteDatabase("a3.cabin.reports");
                
            
                request.onsuccess = function(){
                     deferred.resolve();
                }
                
                request.onerror = function (ex) {
                        deferred.reject(ex);
                    };
                
                request.onabort = function (ex) {
                        deferred.reject(ex);
                    };
                
                return deferred.promise;
                
            },
            info: function(storeName) {
                var deferred = $q.defer();

                var info = function (db) {
                    var tx = db.transaction([storeName], "readonly");
                    var store = tx.objectStore(storeName);

                    store.indexNames;
                    store.keyPath;
                    
                    var indexes = "No indexes Found"
                    if (store.indexNames && store.indexNames.length>0){
                        indexes = "Indexes :: "
                        for (var i = 0; i < store.indexNames.length; i++) {
                           if(i<store.indexNames.length-1){
                              indexes = indexes + store.indexNames[i] + ",";
                           }else {
                               indexes = indexes + store.indexNames[i];
                           }    
                        }
                    }

                    var keypath = store.keyPath ? "Keypath :: " + store.keyPath : "No keypath";
                    var errorMsg = "Store ::" + storeName + " - "+indexes + " - " + keypath;
                    LogService.debug(errorMsg);

                    tx.oncomplete = function (e) {
                        // All requests have succeeded and the transaction has committed.
                        deferred.resolve();
                    };

                    tx.onerror = function (ex) {
                        deferred.reject(ex);
                    };
                    tx.onabort = function (ex) {
                        deferred.reject(ex);
                    };
                }

                if (idbSupported) {
                    this.init().then(info);
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            },
         
            /**
             * Add  the  object
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {object} entity The object to add
             * @returns {object} promise
             */
            add: function (storeName, entity) {
                var deferred = $q.defer();

                var add = function (db) {
                    var tx = db.transaction([storeName], "readwrite");
                    var store = tx.objectStore(storeName);

                    store.add(entity);

                    tx.oncomplete = function (e) {
                        // All requests have succeeded and the transaction has committed.
                        deferred.resolve(entity.id);
                    };

                    tx.onerror = function (ex) {
                        deferred.reject(ex);
                    };
                    tx.onabort = function (ex) {
                        deferred.reject(ex);
                    };
                }

                if (idbSupported) {
                    this.init().then(add);
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            },
            /**
             * Add all the  objects
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {array} entity The objects to add
             * @returns {object} promise
             */
            addAll: function (storeName, entity) {
                var deferred = $q.defer();

                var add = function (db) {
                    var tx = db.transaction([storeName], "readwrite");
                    var store = tx.objectStore(storeName);
                    var count = 0;
                    //Insert several objects: [{obj},{obj},{obj}]
                    for (var i = 0; i < entity.length; i++) {
                        store.add(entity[i]);
                        count++;
                    }
                    tx.oncomplete = function (e) {
                        // All requests have succeeded and the transaction has committed.
                        deferred.resolve(count);
                    };

                    tx.onerror = function (ex) {
                        deferred.reject(ex);
                    };
                    tx.onabort = function (ex) {
                        deferred.reject(ex);
                    };

                    //db.close();
                }

                if (idbSupported) {
                    this.init().then(add);
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            },
            /**
             * update object
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {array} entity The object to update
             * @returns {object} promise
             */
            put: function (storeName, entity) {
                var deferred = $q.defer();

                var put = function (db) {
                    var tx = db.transaction([storeName], "readwrite");
                    var store = tx.objectStore(storeName);

                    store.put(entity);

                    tx.oncomplete = function () {
                        // All requests have succeeded and the transaction has committed.
                        deferred.resolve(tx.result);
                    };

                    tx.onerror = function () {
                        deferred.reject(tx);
                    };
                    tx.onabort = function () {
                        deferred.reject(tx);
                    };
                }

                if (idbSupported) {
                    this.init().then(put);
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            },

            /**
             * Get the requested object by the default index
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {number} id The unique identifier
             * @returns {object} promise
             */
            getById: function (storeName, id) {
                var deferred = $q.defer();

                var getById = function (db) {

                    var tx = db.transaction([storeName], "readonly");
                    var store = tx.objectStore(storeName);
                    var index = store.index("id_idx");

                    var request = index.get(id);

                    request.onsuccess = function () {
                        deferred.resolve(request.result);
                    };

                    request.onerror = function () {
                        deferred.reject(request.error);
                    };
                    tx.onabort = function () {
                        deferred.reject(tx.error);
                    };
                }


                if (idbSupported) {
                    this.init().then(getById);
                } else {
                    deferred.resolve(null);
                }

                return deferred.promise;
            },
            /**
             * Get the requested object by the selected index
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {string} indexName A string which identifies the index name
             * @param {number} id The unique identifier
             * @returns {object} promise
             */
            getByIndex: function (storeName, indexName, value) {
                var deferred = $q.defer();

                var getByIndex = function (db) {

                    var tx = db.transaction([storeName], "readonly");
                    var store = tx.objectStore(storeName);
                    var index = store.index(indexName);
                    var request = index.openCursor(IDBKeyRange.only(value)); //IDBKeyRange.only(value)
                    var results = [];
                    request.onsuccess = function () {
                        var cursor = request.result;
                        if (cursor) {
                            results.push(cursor.value);
                            cursor.continue();
                        } else {
                            deferred.resolve(results);
                        }
                    };
                    request.onerror = function (r) {
                        deferred.reject(r.error);
                    };
                    tx.onabort = function (r) {
                        deferred.reject(r.error);
                    };
                }

                if (idbSupported) {
                    this.init().then(getByIndex);
                } else {
                    deferred.resolve(null);
                }


                return deferred.promise;
            },
            /**
             * Get the all objects of the selected store
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {string} indexName A string which identifies the index name (optional)
             * @returns {object} promise
             */
            getAll: function (storeName, indexName) {
                var deferred = $q.defer();
                if (indexName === undefined) indexName = 'id_idx';

                var all = function (db) {
                    var tx = db.transaction([storeName], "readonly");
                    var store = tx.objectStore(storeName);
                    //var index = store.index(indexName);

                    var request = store.openCursor(); //IDBKeyRange.only("Fred")
                    var results = [];
                    request.onsuccess = function () {
                        var cursor = request.result;
                        if (cursor) {
                            results.push(cursor.value);
                            cursor.continue();
                        } else {
                            deferred.resolve(results);
                        }
                    };
                    request.onerror = function () {
                        LogService.error(request.error);
                        deferred.reject(request.error);
                    };
                    tx.onabort = function () {
                        deferred.reject(tx.error);
                    };
                }

                if (idbSupported) {
                    this.init().then(all);
                } else {
                    deferred.resolve([]);
                }

                return deferred.promise;
            },
            /**
             * Count  all objects of the selected store
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {string} indexName A string which identifies the index name (optional)
             * @returns {object} promise
             */
            count: function (storeName, indexName) {
                var deferred = $q.defer();
                if (indexName === undefined) indexName = 'id_idx';

                var count = function (db) {
                    var tx = db.transaction([storeName], "readonly");
                    var store = tx.objectStore(storeName);
                    var index = store.index(indexName);

                    var request = index.count();
                    request.onsuccess = function () {
                        deferred.resolve(request.result);
                    };
                    request.onerror = function () {
                        deferred.reject(request.error);
                    };
                    tx.onabort = function () {
                        deferred.reject(tx.error);
                    };
                }

                if (idbSupported) {
                    this.init().then(count);
                } else {
                    deferred.resolve(0);
                }

                return deferred.promise;
            },
            /**
             * Delete the requested object
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {number} id The unique identifier
             * @returns {object} promise
             */
            remove: function (storeName, id) {
                var deferred = $q.defer();

                var remove = function (db) {

                    var tx = db.transaction([storeName], "readwrite");
                    var store = tx.objectStore(storeName);

                    store.delete(id);

                    tx.oncomplete = function (e) {
                        // All requests have succeeded and the transaction has committed.
                        deferred.resolve(id);
                    };

                    tx.onerror = function (r) {
                        deferred.reject(r.error);
                    };
                    tx.onabort = function (r) {
                        deferred.reject(r.error);
                    };
                }


                if (idbSupported) {
                    this.init().then(remove);
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            },
            /**
             * Delete the requested object by the selected index
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @param {string} indexName A string which identifies the index name (optional)
             * @param {number} id The unique identifier
             * @returns {object} promise
             */
            removeByIndex: function (storeName, indexName, value) {
                var deferred = $q.defer();

                var removeByIndex = function (db) {

                    var tx = db.transaction([storeName], "readwrite");
                    var store = tx.objectStore(storeName);
                    var index = store.index(indexName);
                    var request = index.openKeyCursor(IDBKeyRange.only(value)); //IDBKeyRange.only(value)
                    var results = [];

                    request.onsuccess = function () {
                        var cursor = request.result;
                        if (cursor) {
                            store.delete(cursor.primaryKey);
                            cursor.continue();
                        } else {
                            deferred.resolve(results);
                        }
                    };
                    request.onerror = function (r) {
                        deferred.reject(r.error);
                    };
                    tx.onabort = function (r) {
                        deferred.reject(r.error);
                    };
                }


                if (idbSupported) {
                    this.init().then(removeByIndex);
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            },
            /**
             * Delete all the objects
             * @memberof IndexedDBService
             * @param {string} storeName A string which identifies the IndexedDB storage
             * @returns {object} promise
             */
            removeAll: function (storeName) {
                var deferred = $q.defer();

                var remove = function (db) {

                    var tx = db.transaction([storeName], "readwrite");
                    var store = tx.objectStore(storeName);

                    store.clear();

                    tx.oncomplete = function (e) {
                        // All requests have succeeded and the transaction has committed.
                        deferred.resolve('success');
                    };

                    tx.onerror = function (r) {
                        deferred.reject(r.error);
                    };
                    tx.onabort = function (r) {
                        deferred.reject(r.error);
                    };

                    //db.close();
                }

                if (idbSupported) {
                    this.init().then(remove);
                } else {
                    deferred.resolve();
                }

                return deferred.promise;

            }
        };
    }

})();